





































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';

import bButton from 'bootstrap-vue/es/components/button/button';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bInputGroup from 'bootstrap-vue/es/components/input-group/input-group';
import bInputGroupAppend from 'bootstrap-vue/es/components/input-group/input-group-append';
import bInputGroupPrepend from 'bootstrap-vue/es/components/input-group/input-group-prepend';
import bRow from 'bootstrap-vue/es/components/layout/row';

import { ProductVariant } from '@/models';

const QuantityInputProps = Vue.extend({
  props: {
    variant: {
      type: ProductVariant,
      required: true,
    },
  },
});

@Component({
  components: {
    FontAwesomeIcon,

    bButton,
    bCol,
    bFormInput,
    bInputGroup,
    bInputGroupAppend,
    bInputGroupPrepend,
    bRow,
  },
  props: {
    // Allow two-way binding with v-model.
    value: {
      type: Number,
      required: true,
    },
  },
})
export default class QuantityInput extends QuantityInputProps {
  public readonly faPlus = faPlus;
  public readonly faMinus = faMinus;

  get maxQuantity() {
    if (this.variant.inventory) {
      return this.variant.inventory.quantity;
    }
    return 0;
  }

  public setQuantity(quantity: any) {
    if (!Number.isInteger(quantity)) {
      quantity = parseInt(quantity, 10);
    }
    if (!Number.isInteger(quantity)) {
      this.$emit('input', 1);
      return;
    }

    if (quantity < 1) {
      this.$emit('input', 1);
      return;
    }

    const maxQuantity = this.maxQuantity;
    if (this.variant.inventory && quantity > maxQuantity) {
      this.$emit('input', maxQuantity);
      return;
    }

    this.$emit('input', quantity);
  }
}

